import { put, takeLatest } from 'redux-saga/effects';
import { CreateLicense } from '../../reducers/r_index';

import authService from './../../components/api-authorization/AuthorizeService';


// worker saga: makes the api call when triggerAction sees the action
export function* runAction({ payload: { anno } }) {
    try {
        //GetCodiciUtente
        const token = yield authService.getAccessToken();

        const response = yield fetch('/User/GetCodiciUtente', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });

        const codici_utente = yield response.json();

        //GenPK
        const token2 = yield authService.getAccessToken();

        const response2 = yield fetch('/Licenses/GenPK', {
            headers: !token2 ? {} : { 'Authorization': `Bearer ${token2}` }
        });

        const product_key = yield response2.text();

        //GenSN
        const token3 = yield authService.getAccessToken();

        const response3 = yield fetch('/Licenses/GenSN/' + anno, {
            headers: !token3 ? {} : { 'Authorization': `Bearer ${token3}` }
        });

        const sn_quattro_cifre = yield response3.text();


        yield put(CreateLicense.creators.initializeNewLicenseDataSuccess({ codici_utente, product_key, sn_quattro_cifre }));


    } catch (e) {
        yield put(CreateLicense.creators.initializeNewLicenseDataFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(CreateLicense.types.INITIALIZE_NEW_LICENSE_DATA_REQUEST, runAction);
}

